export default {
  "admin.title": "Admin panel",
  "admin.overview": "Overview",
  "admin.providers": "Providers",
  "admin.bookings": "Bookings",
  "admin.reviews": "Reviews",
  "admin.coupons": "Coupons",
  "admin.salesTotal": "Total sales",
  "admin.salesToday": "Today's sales",
  "admin.activeProviders": "Active providers",
  "admin.pendingProviders": "Pending",
  "admin.totalCustomers": "Customers",
  "admin.totalTours": "Active tours",
  "admin.commission": "Commission",
  "admin.commissionRate": "Commission rate",
  "admin.recentBookings": "Recent bookings",
  "admin.recentReviews": "Recent reviews",
  "admin.providerName": "Provider",
  "admin.providerEmail": "Email",
  "admin.providerStatus": "Status",
  "admin.providerVerified": "Verified",
  "admin.providerActions": "Actions",
  "admin.approve": "Approve",
  "admin.reject": "Reject",
  "admin.suspend": "Suspend",
  "admin.activate": "Activate",
  "admin.search": "Search...",
  "admin.filter": "Filter",
  "admin.all": "All",
  "admin.couponCode": "Code",
  "admin.couponDiscount": "Discount",
  "admin.couponExpiry": "Expires",
  "admin.couponUsage": "Uses",
  "admin.addCoupon": "New coupon",
  "admin.reviewTour": "Tour",
  "admin.reviewUser": "User",
  "admin.reviewRating": "Rating",
  "admin.reviewComment": "Comment",
  "admin.reviewDate": "Date",
  "admin.reviewActions": "Actions",
  "admin.approveReview": "Approve",
  "admin.rejectReview": "Reject",
  "admin.settings": "Settings",
  "admin.settingsDesc": "Configure the platform",
  "admin.platformName": "Platform name",
  "admin.contactEmail": "Contact email",
  "admin.bookingCommission": "Booking commission",
  "admin.commissionDesc": "Platform fee percentage taken from each booking",
  "admin.currency": "Primary currency",
  "admin.defaultLanguage": "Default language",
  "admin.bookingSettings": "Bookings",
  "admin.bookingSettingsDesc": "Rules for new bookings",
  "admin.autoConfirm": "Auto-confirm bookings",
  "admin.autoConfirmDesc": "Approve bookings without manual review",
  "admin.cancellationPeriod": "Free cancellation up to",
  "admin.hoursBefore": "hours before",
  "admin.maxGuests": "Max guests per booking",
  "admin.notificationSettings": "Notifications",
  "admin.notificationSettingsDesc": "Emails the admin receives",
  "admin.emailNewBooking": "New booking",
  "admin.emailNewBookingDesc": "Get an email when a new booking is made",
  "admin.emailNewProvider": "New provider",
  "admin.emailNewProviderDesc": "Get an email when a provider registers",
  "admin.emailNewReview": "New review",
  "admin.emailNewReviewDesc": "Get an email when a review is posted",
  "admin.emailDailyReport": "Daily report",
  "admin.emailDailyReportDesc": "Get a daily sales summary",
  "admin.paymentMethods": "Payment methods",
  "admin.paymentMethodsDesc": "Configure payment integrations",
  "admin.mercadoPago": "Mercado Pago",
  "admin.mercadoPagoDesc": "Card, OXXO and SPEI payments",
  "admin.mpPublicKey": "Public Key",
  "admin.mpPublicKeyHint": "Use the public key from your Mercado Pago application",
  "admin.mpAccessToken": "Access Token",
  "admin.mpAccessTokenHint": "Access token for processing payments from the backend",
  "admin.mpWebhookUrl": "Webhook URL",
  "admin.mpWebhookHint": "Set this URL in your Mercado Pago dashboard",
  "admin.mpTestMode": "Test mode",
  "admin.mpTestModeDesc": "Use test credentials without real charges",
  "admin.mpConnected": "Connected",
  "admin.mpLastChecked": "Last checked",
  "admin.saveSettings": "Save changes",
  "admin.noData": "No data",
  "admin.page": "Page",
  "admin.of": "of",

  // Shared
  "admin.loading": "Loading…",
  "admin.view": "View",
  "admin.save": "Save",
  "admin.saving": "Saving…",
  "admin.saved": "Saved.",

  // Audit log
  "admin.aud.title": "Audit log",
  "admin.aud.search": "Search by path or user…",
  "admin.aud.date": "Date",
  "admin.aud.method": "Method",
  "admin.aud.path": "Path",
  "admin.aud.user": "User",
  "admin.aud.ip": "IP",
  "admin.aud.status": "Status",
  "admin.aud.empty": "No audit records.",

  // Commissions
  "admin.com.title": "Commissions",
  "admin.com.pending": "Pending payout",
  "admin.com.settledTotal": "Total settled",
  "admin.com.providers": "Providers",
  "admin.com.provider": "Provider",
  "admin.com.pendingBookings": "Pending bookings",
  "admin.com.pendingNet": "Pending (net)",
  "admin.com.settledNet": "Settled (net)",
  "admin.com.empty": "No commissions yet. They are generated when a booking becomes Completed.",
  "admin.com.settle": "Mark settled",
  "admin.com.settling": "Settling…",
  "admin.com.upToDate": "Up to date",

  // Products
  "admin.prod.title": "Products",
  "admin.prod.search": "Search by title or provider…",
  "admin.prod.tour": "Tour",
  "admin.prod.provider": "Provider",
  "admin.prod.category": "Category",
  "admin.prod.price": "Price",
  "admin.prod.status": "Status",
  "admin.prod.empty": "No products.",
  "admin.prod.statusActive": "Active",
  "admin.prod.statusPaused": "Paused",
  "admin.prod.statusArchived": "Archived",

  // Tour categories
  "admin.cat.title": "Categories",
  "admin.cat.desc": "Catalog categories (fixed set). Active-tour count per category.",
  "admin.cat.viewTours": "View tours",
  "admin.cat.tours": "tours",
  "admin.cat.adventure": "Adventure",
  "admin.cat.cultural": "Cultural",
  "admin.cat.gastronomic": "Gastronomic",
  "admin.cat.transport": "Transport",
  "admin.cat.housing": "House rentals",
  "admin.cat.fishing": "Fishing",

  // Destinations
  "admin.dest.title": "Destinations",
  "admin.dest.desc": "Destinations with active tours in the catalog (derived from tour locations).",
  "admin.dest.destination": "Destination",
  "admin.dest.activeTours": "Active tours",
  "admin.dest.empty": "No destinations with active tours.",

  // Users
  "admin.users.title": "Users",
  "admin.users.search": "Search by name or email…",
  "admin.users.name": "Name",
  "admin.users.email": "Email",
  "admin.users.role": "Role",
  "admin.users.bookings": "Bookings",
  "admin.users.marketing": "Offers",
  "admin.users.marketingYes": "Opted in",
  "admin.users.marketingNo": "Not opted in",
  "admin.users.joined": "Joined",
  "admin.users.empty": "No users.",
  "admin.users.tourist": "Tourist",
  "admin.users.provider": "Provider",
  "admin.users.admin": "Admin",

  // Reports
  "admin.rep.title": "Reports",
  "admin.rep.tabSales": "Sales",
  "admin.rep.tabCommissions": "Commissions",
  "admin.rep.tabProviders": "Top providers",
  "admin.rep.tabProducts": "Top products",
  "admin.rep.tabUsers": "Growth",
  "admin.rep.export": "Export bookings (CSV)",
  "admin.rep.exporting": "Exporting…",
  "admin.rep.totalSales": "Total sales",
  "admin.rep.totalBookings": "Total bookings",
  "admin.rep.avgTicket": "Average ticket",
  "admin.rep.monthlySales": "Monthly sales",
  "admin.rep.noSales": "No sales data yet.",
  "admin.rep.totalCommission": "Total commission",
  "admin.rep.commission30d": "Commission (30 days)",
  "admin.rep.takeRate": "Commission rate",
  "admin.rep.monthlyCommission": "Monthly commission",
  "admin.rep.topProvidersTitle": "Highest-earning providers",
  "admin.rep.topProvidersDesc": "Top 10 by accumulated net amount. The number on the right is settled plus pending bookings.",
  "admin.rep.noProviders": "No payouts recorded yet.",
  "admin.rep.topProductsTitle": "Best-selling products",
  "admin.rep.topProductsDesc": "Top 10 by accumulated gross sales. The number on the right is the booking count.",
  "admin.rep.noProducts": "No bookings recorded yet.",
  "admin.rep.totalUsers": "Total users",
  "admin.rep.activeProviders": "Active providers",
  "admin.rep.activeTours": "Active tours",
  "admin.rep.monthlyBookings": "Bookings per month",

  // Notifications (broadcast)
  "admin.notif.title": "Notifications",
  "admin.notif.send": "Send announcement",
  "admin.notif.desc": "Create a notification that will appear in the recipients' notification center.",
  "admin.notif.recipients": "Recipients",
  "admin.notif.providers": "Providers",
  "admin.notif.clients": "Clients",
  "admin.notif.allAudience": "Everyone (providers and clients)",
  "admin.notif.subject": "Title",
  "admin.notif.subjectPlaceholder": "e.g. Scheduled maintenance",
  "admin.notif.message": "Message",
  "admin.notif.messagePlaceholder": "Write the announcement…",
  "admin.notif.sending": "Sending…",
  "admin.notif.sentTo": "Sent to {{count}} user(s).",
  "admin.notif.error": "Could not send the announcement.",

  // Settings
  "admin.cfg.title": "Settings",
  "admin.cfg.general": "General",
  "admin.cfg.platformName": "Platform name",
  "admin.cfg.supportEmail": "Support email",
  "admin.cfg.defaultCommission": "Default commission (%)",
  "admin.cfg.commissionHint": "Applies to providers who register from now on.",
  "admin.cfg.currency": "Currency",
  "admin.cfg.commissionRange": "Commission must be between 0 and 100.",
  "admin.cfg.saveError": "Could not save.",

  // Settings — database backup
  "admin.cfg.dbTitle": "Database",
  "admin.cfg.dbDesc": "Download a full copy of the database (schema and data) as a .sql file. Keep it somewhere safe; it contains all platform data.",
  "admin.cfg.dbExport": "Download backup (.sql)",
  "admin.cfg.dbExporting": "Generating…",
  "admin.cfg.dbExportError": "Could not generate the backup.",
  "admin.cfg.dbExportDone": "Backup downloaded.",

  // Content (featured tours)
  "admin.content.title": "Content",
  "admin.content.heading": "Featured tours on the homepage",
  "admin.content.search": "Search tour or provider…",
  "admin.content.tour": "Tour",
  "admin.content.provider": "Provider",
  "admin.content.featured": "Featured",
  "admin.content.empty": "No tours.",
  "admin.content.featureTour": "Feature tour",

  // Settings — currency
  "admin.cfg.currencyMxn": "MXN — Mexican Peso",
  "admin.cfg.currencyUsd": "USD — US Dollar",

  // Layout / navigation
  "admin.nav.dashboard": "Dashboard",
  "admin.nav.providers": "Providers",
  "admin.nav.products": "Products",
  "admin.nav.bookings": "Bookings",
  "admin.nav.users": "Users",
  "admin.nav.commissions": "Commissions",
  "admin.nav.coupons": "Coupons",
  "admin.nav.events": "Events",
  "admin.nav.reviews": "Reviews",
  "admin.nav.categories": "Categories",
  "admin.nav.destinations": "Destinations",
  "admin.nav.reports": "Reports",
  "admin.nav.notifications": "Notifications",
  "admin.nav.content": "Content",
  "admin.nav.settings": "Settings",
  "admin.nav.audit": "Audit log",
  "admin.roleLabel": "Administrator",
  "admin.roleAdmin": "Admin",
  "admin.backToSite": "Back to site",

  // Dashboard (page.tsx)
  "admin.loadError": "We couldn't load the dashboard.",
  "admin.lifetimeGross": "Gross sales (total)",
  "admin.pendingReview": "to verify",
  "admin.activeTours": "Active tours",
  "admin.totalUsers": "total users",
  "admin.gross30d": "Sales last 30 days",
  "admin.commission30d": "Commission last 30 days",
  "admin.bookings30d": "Bookings last 30 days",
  "admin.monthlyChart": "Sales by month (last 12)",
  "admin.noRevenueYet": "No revenue to chart yet.",
  "admin.gross": "Gross sales",
  "admin.seeAll": "See all",
  "admin.noBookings": "No bookings yet.",
  "admin.refColumn": "Ref",
  "admin.customer": "Customer",
  "admin.tour": "Tour",
  "admin.provider": "Provider",
  "admin.total": "Total",
  "admin.status": "Status",
  "admin.date": "Date",
  "admin.actions": "Actions",
  "admin.noMatches": "No results match the filters.",

  // Booking statuses
  "admin.statusConfirmed": "Confirmed",
  "admin.statusPending": "Pending",
  "admin.statusCompleted": "Completed",
  "admin.statusCancelled": "Cancelled",

  // Providers (page.tsx + DocumentsPanel)
  "admin.statusActive": "Active",
  "admin.statusSuspended": "Suspended",
  "admin.confirmVerify": "Verify and activate this provider?",
  "admin.actionError": "Error performing the action.",
  "admin.suspendReason": "Reason for suspension (optional):",
  "admin.searchPlaceholder": "Search by company, email or location",
  "admin.noProviders": "No matches.",
  "admin.companyColumn": "Company",
  "admin.ownerColumn": "Owner",
  "admin.locationColumn": "Location",
  "admin.toursColumn": "Tours",
  "admin.revenueColumn": "Sales",
  "admin.commissionColumn": "Commission",
  "admin.verify": "Verify",
  "admin.reactivate": "Reactivate",
  "admin.docs": "Docs",
  "admin.hideDocs": "Hide docs",
  "admin.docTypeIne": "INE",
  "admin.docTypeProofOfAddress": "Proof of address",
  "admin.docTypeCurp": "CURP",
  "admin.docTypeActaConstitutiva": "Articles of incorporation",
  "admin.docVerified": "Verified",
  "admin.docRejected": "Rejected",
  "admin.docInReview": "In review",
  "admin.docsLoading": "Loading documents…",
  "admin.docsEmpty": "No documents uploaded.",
  "admin.docVerify": "Verify",
  "admin.docReject": "Reject",
  "admin.docRejectReason": "Reason for rejection (optional):",

  // Coupons (page.tsx)
  "admin.cou.title": "Coupons",
  "admin.cou.new": "New coupon",
  "admin.cou.edit": "Edit coupon",
  "admin.cou.loadError": "We couldn't load the coupons.",
  "admin.cou.empty": "No coupons yet. Create the first one.",
  "admin.cou.code": "Code",
  "admin.cou.discount": "Discount",
  "admin.cou.validity": "Validity",
  "admin.cou.uses": "Uses",
  "admin.cou.status": "Status",
  "admin.cou.active": "Active",
  "admin.cou.inactive": "Inactive",
  "admin.cou.editAction": "Edit",
  "admin.cou.deactivate": "Deactivate",
  "admin.cou.noExpiry": "no expiry",
  "admin.cou.until": "until {{date}}",
  "admin.cou.from": "from {{date}}",
  "admin.cou.description": "Description (optional)",
  "admin.cou.discountType": "Discount type",
  "admin.cou.percent": "Percentage",
  "admin.cou.fixed": "Fixed amount",
  "admin.cou.percentLabel": "Percentage (1–100)",
  "admin.cou.amountLabel": "Amount (MXN)",
  "admin.cou.validFrom": "From",
  "admin.cou.validUntil": "Until",
  "admin.cou.maxUses": "Max uses (optional)",
  "admin.cou.noLimit": "No limit",
  "admin.cou.activeLabel": "Active",
  "admin.cou.cancel": "Cancel",
  "admin.cou.save": "Save",
  "admin.cou.confirmDeactivate": "Deactivate coupon {{code}}?",
  "admin.cou.errCodeRequired": "Code is required.",
  "admin.cou.errPercentRange": "Percentage must be between 1 and 100.",
  "admin.cou.errAmountPositive": "Amount must be greater than 0.",
  "admin.cou.errSave": "An error occurred while saving.",

  // Reviews (page.tsx)
  "admin.res.title": "Reviews",
  "admin.res.loadError": "We couldn't load the reviews.",
  "admin.res.empty": "No reviews in this view.",
  "admin.res.tabPending": "Pending",
  "admin.res.tabApproved": "Approved",
  "admin.res.tabRejected": "Rejected",
  "admin.res.tabAll": "All",
  "admin.res.sourceVerified": "Verified",
  "admin.res.statusApproved": "Approved",
  "admin.res.statusRejected": "Rejected",
  "admin.res.statusPending": "Pending",
  "admin.res.approve": "Approve",
  "admin.res.reject": "Reject",
  "admin.res.withdraw": "Withdraw",

  // Reports — CSV headers
  "admin.rep.csvReference": "Reference",
  "admin.rep.csvDate": "Date",
  "admin.rep.csvTour": "Tour",
  "admin.rep.csvProvider": "Provider",
  "admin.rep.csvCustomer": "Customer",
  "admin.rep.csvEmail": "Email",
  "admin.rep.csvAdults": "Adults",
  "admin.rep.csvChildren": "Children",
  "admin.rep.csvTotal": "Total",
  "admin.rep.csvCommission": "Commission",
  "admin.rep.csvCurrency": "Currency",
  "admin.rep.csvStatus": "Status",
};